import { render, staticRenderFns } from "./FallbackImage.vue?vue&type=template&id=9c3bde90"
var script = {}
import style0 from "./FallbackImage.vue?vue&type=style&index=0&id=9c3bde90&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports